'use client'

import { convertRuby } from '@entities/lesson'
import { useSuspenseQuery } from '@tanstack/react-query'
import { clsx } from 'clsx'
import { memo } from 'react'

type Props = {
  text: React.ReactNode
  translation: React.ReactNode
  className?: string
}

export const PronounceRuby = memo(({ text, className, translation }: Props) => {
  return (
    <ruby style={{ rubyAlign: 'center', rubyPosition: 'over', display: 'inline' }}>
      {text}
      <rp>(</rp>
      <rt className={clsx(`text-gray-400 text-[11px] font-bold mb-0.5`, className)}>{translation}</rt>
      <rp>)</rp>
    </ruby>
  )
})

type PronounceRubyRequestProps = {
  text: string
  highlight?: number[]
  highlightClassName?: string
}

export const PronounceRubyRequest = ({ text, highlight, highlightClassName }: PronounceRubyRequestProps) => {
  const { data: result } = useSuspenseQuery({
    queryKey: [text, highlight],
    queryFn: () => convertRuby({ text, highlight }).then((res) => res.result),
    staleTime: Infinity,
  })
  return result.map(({ text, furigana, isHighlighted = false }, index) => {
    if (furigana) {
      return (
        <ruby key={`${text}-${index}`} className={isHighlighted ? highlightClassName : ''}>
          {text}
          <rt>{furigana}</rt>
        </ruby>
      )
    } else {
      return (
        <span key={`${text}-${index}`} className={clsx(isHighlighted ? highlightClassName : '')}>
          {text}
        </span>
      )
    }
  })
}
